const messagesJa = {
  about: 'について',
  acceptanceCriteria: '受入基準',
  accomplishments: '実績',
  actions: 'アクション',
  activity: 'アクティビティ',
  activatePod: 'PODを有効化',
  activePods: 'アクティブPOD',
  add: '追加',
  addBlocker: 'ブロッカー情報を追加',
  addingCandidateWait: '候補者を追加中、お待ちください...',
  addPortfolio: 'ポートフォリオを追加',
  addStakeholder: 'ステークホルダーを追加',
  addVideoUpdate: 'ビデオ更新を追加',
  findAgents: 'エージェントを検索',
  all: 'すべて',
  allReporters: 'すべてのレポーター',
  allRepoCheckins: 'すべてのリポジトリチェックイン',
  approve: '承認',
  approved: '承認済み',
  approvalRequests: '承認リクエスト',
  approvedPRCount: '承認済みPR数',
  assignedItems: '割り当てられたアイテム',
  availability: '可用性',
  availableDate: '利用可能日',
  backToPods: '私のPODに戻る',
  basicInformation: '基本情報',
  blocker: 'ブロッカー',
  blockerDetails: 'ブロッカーの詳細',
  blockers: 'ブロッカー',
  board: 'ボード',
  browseTalent: 'タレントを参照',
  bugs: 'バグ',
  calendlyUrl: 'Calendly URL',
  cancel: 'キャンセル',
  candidates: '候補者',
  categories: 'カテゴリ',
  certifications: '認定',
  certificationUrl: '認定URL',
  checkBoxBlocker: 'これがブロッカーの場合、このボックスをチェックしてください',
  ciCdPipeline: 'CI/CDパイプライン',
  clear: 'クリア',
  client: 'クライアント',
  clickHereUploadVideoClip: 'ビデオクリップをアップロードするにはここをクリック！',
  cloudCost: 'クラウドコスト',
  code: 'コード行数',
  codeSmells: 'コードスメル',
  commentHere: 'ここにコメント...',
  category: 'カテゴリ',
  comments: 'コメント',
  companyName: '会社名',
  copied: 'コピー済み！',
  copyright: '著作権 © 2025-現在 Brilli Global, Inc. すべての権利予約。',
  copyToClipboard: 'クリップボードにコピー',
  cost: 'コスト',
  costDetails: 'コストの詳細',
  country: '国',
  create: '作成',
  createArt: 'ARTを作成',
  createGig: 'ソリューションを作成',
  createPod: 'PODを作成',
  createProfile: 'プロフィールを作成',
  createProfileOpportunity: '様々なリモートワークの機会に含まれるために、私たちのタレントデータベースにあなたのプロフィールを作成してください。',
  createTask: 'タスクを作成',
  createYourOwnPod: '独自のPODを作成してプロジェクトを参照',
  creatingProfile: 'プロフィールを作成中',
  currency: '通貨',
  currentlyAvailable: '現在利用可能',
  currentWeek: '今週',
  dashboard: 'ダッシュボード',
  date: '日付',
  dateRangeFilter: '日付範囲フィルター',
  deactivatePod: 'PODを無効化',
  deactivateToUpdate: 'PODを更新するためにPODを無効化してください！',
  defects: '欠陥',
  delete: '削除',
  deletePod: 'PODを削除',
  description: '説明',
  detailsForGitHubRepo: 'GitHubリポジトリの詳細',
  done: '閉じる',
  Done: '完了',
  doraMetrics: 'Doraメトリクス',
  dueDate: '期限',
  duplicatedLinesDensity: '重複行密度',
  edit: '編集',
  education: '教育',
  educationAndCertifications: '教育と認定',
  email: 'メール',
  podTime: 'POD時間',
  createHub: 'ハブを作成',
  createSolution: 'ソリューションを作成',
  podVelocity: 'PODベロシティ',
  podBlockers: 'PODブロッカー',
  podsync: 'POD同期',
  endDate: '終了日',
  enterEmailToInvite: '招待するメールアドレスを入力',
  enterPodMission: 'PODミッションを入力',
  enterPodName: 'POD名を入力',
  enterStoryDescription: 'ストーリーの説明を入力',
  executionDate: '実行日',
  executionID: '実行ID',
  externalPod: '外部POD',
  fileNameNoSpaces: 'ファイル名にはすべての要素や文字間にスペースを含めないでください',
  fileUpload: 'ファイルアップロード',
  findBestFreelancers: 'プロジェクトをより速いペースで配信するために、最高のフリーランサーやタレントPODを見つけてください！',
  findBestPod: 'あなたの経験/スキルセットに合うPODを見つける',
  findPods: 'PODを検索',
  findTalent: 'タレントを検索',
  findYourBestTalentPod: 'あなたの最高のタレントPODを見つける',
  firstName: '名',
  focus: 'フォーカス',
  gitHubRepo: 'GitHubリポジトリ',
  gitHubUsername: 'GitHubユーザー名',
  github: 'Github',
  githubSummary: 'GitHub要約',
  githubUrl: 'Github URL',
  githubUser: 'GitHubユーザー',
  giveRating: '評価を与える',
  globalWorkPlatform: 'グローバルワークプラットフォーム',
  home: 'ホーム',
  hoursPerWeek: '週あたりの時間',
  inactivePod: '非アクティブPOD',
  individual: '個人',
  industry: '業界',
  inProgress: '進行中',
  institute: '機関',
  internalPod: '内部POD',
  invite: '招待',
  invoices: '請求書',
  issueKey: '課題キー',
  issueStatus: '課題ステータス',
  issueSummary: '課題要約',
  jiraIssue: 'Jira課題',
  jiraIssues: 'Jira課題',
  jiraItem: 'Jiraアイテム',
  jiraTimeDetails: '時間ログ',
  jiraUsername: 'Jiraユーザー名',
  keepDoing: '続ける',
  keyword: 'キーワード',
  languageSpoken: '話せる言語',
  lastName: '姓',
  latestSprintVelocity: '最新スプリントベロシティ',
  linkedIn: 'LinkedIn',
  linkedInUrl: 'LinkedIn URL',
  linesOfCodeByDay: '日別コード行数',
  listOfTalents: 'タレントリスト',
  loading: '読み込み中',
  loadingAcceptanceCriteria: '受入基準を読み込み中',
  loadingStoryDescription: 'ストーリー説明を読み込み中',
  loadingTestCases: 'テストケースを読み込み中',
  logOut: 'ログアウト',
  login: 'ログイン',
  manage: '管理',
  manageActivities: '日々のPODアクティビティと更新を管理',
  manageProfile: 'プロフィール管理',
  manageProfileHere: 'ここでプロフィールを管理',
  managePod: 'POD管理',
  managePods: 'すべてのPODとそのアクティビティを管理',
  markComplete: '完了としてマーク',
  middleName: 'ミドルネーム',
  myPods: '私のPOD',
  myTasks: '私のタスク',
  name: '名前',
  ncloc: 'Ncloc',
  newActivityUpdate: '新しいアクティビティ更新',
  next: '次へ',
  noArtOptionsAvailable: 'ARTオプションが利用できません',
  noBlockers: 'ブロッカーはありません',
  noCandidates: '候補者が追加されていません',
  noCandidatesAddedToPod: 'PODに候補者が追加されていません！',
  noCandidateReviews: '候補者のレビューはありません。',
  noData: 'データなし',
  noDataAvailable: '利用可能なデータはありません',
  noExperience: '経験なし',
  noMatchingPods: '一致するPODが利用できません',
  noNotifications: '通知はありません',
  noPodActivity: 'PODアクティビティがありません',
  noPods: 'PODがありません',
  noPodTasks: 'PODタスクがありません',
  noReviews: 'レビューはありません。',
  noStakeholders: 'このPODにはステークホルダーがいません',
  noSubscription: 'サブスクリプションプランがありません',
  noVideoAvailable: '利用可能なビデオはありません',
  notifications: '通知受信者',
  otherInformation: 'その他の情報',
  pending: '保留中',
  pendingPods: '保留中POD',
  phoneNumber: '電話番号',
  pipelineExecutionDetails: 'パイプライン実行詳細',
  pipelineName: 'パイプライン名',
  pipelineVersion: 'パイプラインバージョン',
  pleaseEnterStoryDescription: 'ストーリーの説明を入力して送信をクリックしてください',
  POD: 'POD',
  podActivities: 'PODアクティビティ',
  podActivity: 'PODアクティビティ',
  podAnalytics: 'POD分析',
  podAssist: 'PODアシスト',
  podAutomation: 'POD自動化',
  podBoard: 'PODボード',
  podCategories: 'PODカテゴリ',
  podDescription: 'POD説明',
  podExperience: 'POD経験',
  podFeedback: 'PODフィードバック',
  podMetrics: 'PODメトリクス',
  podName: 'POD名',
  podQuery: 'PODクエリ',
  podRequests: 'PODリクエスト',
  podRetro: 'PODレトロ',
  podSize: 'PODサイズ',
  podTasks: 'PODタスク',
  podTaskDescription: 'PODタスク説明',
  podTaskDueDate: 'PODタスク期限',
  podTaskName: 'PODタスク名',
  podTaskOwner: 'PODタスクオーナー',
  podTaskStatus: 'PODタスクステータス',
  podTechStack: 'POD技術スタック',
  podTeamMember: 'PODチームメンバー',
  podType: 'PODタイプ',
  portfolio: 'ポートフォリオ',
  portfolioUrl: 'ポートフォリオURL',
  post: '投稿',
  postActivity: 'アクティビティを投稿',
  postPodActivity: 'PODアクティビティを投稿',
  postRequirement: '要件を投稿',
  posting: '投稿中...',
  postedDate: '投稿日',
  postedRequirements: 'あなたの投稿したPOD要件',
  positionName: 'ポジション名',
  prCount: 'PR数',
  preferredWorkHours: '希望勤務時間',
  prev: '前へ',
  previousPods: '以前のPOD',
  previousWeek: '先週',
  primarySkill: '主要スキル',
  privacyPolicy: 'プライバシーポリシー',
  privatePods: 'プライベートPOD',
  prSummary: 'PR要約',
  projectKey: 'プロジェクトキー',
  profileLink: 'プロフィールリンク',
  profileVisibility: 'プロフィール可視性',
  public: 'パブリック',
  qualification: '資格',
  ratePerHour: '時給',
  ratePerMonth: '月給',
  recentSearches: '最近の検索',
  region: '地域',
  register: '登録',
  resetPassword: 'パスワードリセット',
  restricted: '制限',
  retro: 'レトロ',
  review: 'レビューと評価',
  revisionSummary: 'リビジョン要約',
  revisionURL: 'リビジョンURL',
  resume: '履歴書',
  resumeLink: '履歴書を表示',
  rowsPerPage: 'ページあたりの行数',
  save: '保存',
  search: '検索',
  searchProjects: 'プロジェクトを検索',
  secondarySkill: '副次スキル',
  select: '選択',
  selectArtName: 'ART名を選択',
  selectAUser: 'ユーザーを選択',
  selectFilter: 'フィルターを選択',
  applyFilters: 'フィルターを適用',
  selectItemsPerPage: 'ページあたりのアイテムを選択',
  selectJiraIssues: 'Jira課題を選択',
  selectPod: 'PODを選択',
  selectPodTeamMember: 'PODチームメンバーを選択',
  selectPods: 'PODを選択',
  services: 'サービス',
  setting: '設定',
  shareableLink: '共有可能リンク',
  signUpToGetStarted: '始めるために下記で「サインアップ」してください！',
  getStarted: '開始する',
  skills: 'スキル',
  skillsAndExpertise: 'スキルと専門知識',
  sonarqubeprojectkey: 'Sonarqubeプロジェクトキー',
  sonarqubeStats: 'Sonarqube統計',
  specialization: '専門分野',
  sprintVelocity: 'スプリントベロシティ',
  sprint: 'スプリント',
  spotsLeft: '残り枠',
  startDate: '開始日',
  startDoing: '開始する',
  status: 'ステータス',
  stopDoing: '停止する',
  storyDescription: 'ストーリー説明',
  stories: 'ストーリー',
  submit: '送信',
  submittedDate: '送信日',
  submittedPRCount: '送信済みPR数',
  subscription: 'サブスクリプション',
  talentApprovalRequests: 'タレント承認リクエスト',
  talentCode: 'タレントコード',
  taskForm: 'タスクフォーム',
  taskManager: 'タスクマネージャー',
  taskName: 'タスク名',
  tasks: 'タスク',
  teamMember: 'チームメンバー',
  techStack: '技術スタック',
  termsOfService: '利用規約',
  testCases: 'テストケース',
  time: '時間',
  timeLog: '時間ログ',
  timeSubmit: '時間送信',
  timeZone: 'タイムゾーン',
  toDo: 'TODO',
  todaysFocus: '今日のフォーカス',
  totalLinesChangedLastWeek: '先週変更された総行数',
  totalLinesChangedThisWeek: '今週変更された総行数',
  totalPRCount: '総PR数',
  university: '大学',
  update: '更新',
  updateProfileHere: 'ここでプロフィールを更新',
  updatingVisibility: '可視性を更新中...',
  upload: 'アップロード',
  userStory: 'ユーザーストーリー',
  validFrom: '有効開始日',
  validTill: '有効終了日',
  talentexplorer: 'タレントエクスプローラー',
  interviewrequests: '面接リクエスト',
  videoUrl: 'ビデオURL',
  view: '表示',
  viewActivities: 'アクティビティを表示',
  viewDetails: '詳細を表示',
  viewPodActivities: 'PODアクティビティを表示',
  viewPodDetails: 'POD詳細を表示',
  viewProfile: 'プロフィールを表示',
  viewTasks: 'タスクを表示',
  viewTimeEntries: '時間エントリを表示',
  viewVideo: 'ビデオを表示',
  visitFindTalent: '「タレントを検索」ページを訪問して、才能ある人材をあなたのPODに追加してください。',
  vulnerabilities: '脆弱性',
  welcome: 'Artemy.aiへようこそ！',
  workExperience: '職歴',
  yourPod: 'あなたのPOD',
  yourPods: 'あなたのPOD',
  yourPostedPodActivity: 'あなたの投稿したPODアクティビティ',
  
  findTickets: 'チケットを検索',
  epics: 'エピック',
  date: '日付',
  talent: 'タレント',
  focus: 'フォーカス',
  startDate: '開始日',
  endDate: '終了日',
  status: 'ステータス',
  allStatus: 'すべてのステータス',
  blocked: 'ブロック済み',
  onTrack: '順調',
  activityDetails: 'アクティビティ詳細',
  jiraIssues: 'Jira課題',
  todaysFocus: '今日のフォーカス',
  accomplishments: '実績',
  blockers: 'ブロッカー',
  videoUpdate: 'ビデオ更新',
  comments: 'コメント',
  addBlockerInformation: 'ブロッカー情報を追加',
  blockerDetails: 'ブロッカー詳細',
  cancel: 'キャンセル',
  saveChanges: '変更を保存',
  selectJiraIssues: 'Jira課題を選択',
  design: 'デザイン',
  development: '開発',
  testing: 'テスト',
  bugFix: 'バグ修正',
  documentation: 'ドキュメント',
  myPods: '私のPOD',
  postRetro: 'レトロを投稿',
  newRetro: '新しいレトロ',
  startDoing: '開始する',
  stopDoing: '停止する',
  keepDoing: '続ける',
  viewRetros: 'レトロを表示',
  podRetroFeedback: 'PODレトロフィードバック',
  selectSprint: 'スプリントを選択',
  thisTaskIsBlocker: 'このタスクはブロッカーです',
  category: 'カテゴリ',
  taskCreatedSuccessfully: 'タスクが正常に作成されました！',
  taskManagement: 'タスク管理',
  searchJiraIssues: 'JIRA課題を検索...',
  creatingTask: 'タスクを作成中...',
  createTask: 'タスクを作成',
  description: '説明',
  dueDate: '期限',
  commentsHistory: 'コメント履歴',
  noCommentsYet: 'まだコメントはありません',
  writeAComment: 'コメントを書く...',
  all: 'すべて',
  blockerStatus: 'ブロッカーステータス',
  blockedTasks: 'ブロックされたタスク',
  unblockedTasks: 'ブロックされていないタスク',
  clearDateRange: '日付範囲をクリア',
  selectDateRange: '日付範囲を選択',
  showAllTime: 'すべての時間を表示',
  noTasksFound: 'タスクが見つかりません',
  noLinkedIssues: 'リンクされた課題はありません',
  timeSheet: 'タイムシート',
  podTimeSheet: 'PODタイムシート',
  userStory: 'ユーザーストーリー',
  hours: '時間',
  minutes: '分',
  actions: 'アクション',
  submitTimeEntries: '時間エントリを送信',
  selectCategory: 'カテゴリを選択',
  selectStory: 'ストーリーを選択',
  addRow: '行を追加',
  podSelection: 'POD選択',
  selectPodToView: 'スプリントとタレントフィルターを表示するPODを選択',
  toDo: 'TODO',
  podAssist: 'PODアシスト',
  inProgress: '進行中',
  done: '完了',
  selectPodsRequired: 'PODを選択（必須）',
  enterStoryDescription: 'ストーリー説明を入力',
  podSyncSummaries: 'POD同期要約',
  enterMeetingUrl: 'ミーティングURLを入力...',
  searchInSummaries: '要約内を検索...',
  dateAndTime: '日時',
  quickTimeRange: 'クイック時間範囲',
  sortByDate: '日付で並べ替え',
  selectTalents: 'タレントを選択',
  filterBySpecificCandidates: '特定の候補者でフィルター（オプション）',
  talentSelection: 'タレント選択',
  priority: '優先度',
  addComment: 'コメントを追加',
  taskDetails: 'タスク詳細',
  summary: '要約',
  addMeeting: 'ミーティングを追加',

  podAutomation: 'POD自動化',
  uploading: 'アップロード中...',
  uploadFile: 'ファイルをアップロード',
  send: '送信',
  submitting: '送信中...',
  enterYourQuestionHere: 'ここに質問を入力',
  submitTheResults: '結果を送信',
  export: 'エクスポート',
  podInsights: 'PODインサイト',
  askQuestionsAboutYourPod: 'PODアクティビティ、チームメンバーなどについて質問する',
  welcomeToPodInsights: 'PODインサイトへようこそ！',
  startByAskingQuestionsLike: '次のような質問から始めてください',
  showAllPodActivitiesThatHadBlockers: 'ブロッカーがあったすべてのPODアクティビティを表示',
  listAllCandidatesAndTheirPods: 'すべての候補者とそのPODをリスト',
  showStakeholdersFromIndia: 'インドからのステークホルダーを表示',
  askAnythingAboutYourPods: 'POD、チームメンバー、アクティビティについて何でも質問...',
  sending: '送信中...',
  analyzingYourQuestion: '質問を分析中...',
  pipelineCICD: 'パイプラインCI/CD',
  tickets: 'チケット',
  metricName: 'メトリクス名',
  metricValue: 'メトリクス値',
  commentsHistory: 'コメント履歴',
  noCommentsYet: 'まだコメントはありません',
  writeAComment: 'コメントを書く...',
  solutionManagement: 'ソリューション管理',
  searchSolutions: 'ソリューションを検索...',
  refresh: '更新',
  createNewSolution: '新しいソリューションを作成',
  solutionName: 'ソリューション名',
  solutionDescription: 'ソリューション説明',
  updateSolution: 'ソリューションを更新',
  createSolution: 'ソリューションを作成',
  confirmSolutionDeletion: 'ソリューションを削除してもよろしいですか',
  artManagement: 'ART管理',
  podManagement: 'POD管理',
  searchPods: 'PODを検索...',
  viewPod: 'PODを表示',
  searchARTs: 'ARTを検索...',
  noARTsFound: 'ARTが見つかりません。「新しいARTを作成」ボタンをクリックして最初のARTを作成してください。',
  createNewART: '新しいARTを作成',
  selectGig: 'ギグを選択',
  artName: 'ART名',
  artDescription: 'ART説明',
  createART: 'ARTを作成',
  confirmDeletion: '削除の確認',
  confirmARTDeletion: 'ARTを削除してもよろしいですか',
  primaryLanguage: '主要言語',
  selectSkills: 'スキルを選択',
  timeZone: 'タイムゾーン',
  updateART: 'ARTを更新',
  somethingWentWrong: '何か問題が発生しました',
  reloadPage: 'ページを再読み込み',
  privatePods: 'プライベートPOD',
  activePods: 'アクティブPOD',
  completedPods: '完了したPOD',
  pendingPods: '保留中POD',
  loadingPods: 'PODを読み込み中...',
  retry: '再試行',
  noPodsFound: 'PODが見つかりません',
  createFirstPod: '開始するために最初のPODを作成',
  previous: '前へ',
  showing: '表示中',
  size: 'サイズ',
  teamSize: 'チームサイズ',
  activeMembers: 'アクティブメンバー',
  stakeholders: 'ステークホルダー',
  podManagers: 'PODマネージャー',
  addManager: 'マネージャーを追加',
  podManager: 'PODマネージャー',
  noManagersAssignedYet: 'まだマネージャーが割り当てられていません',
  addManagersToHelpOversee: 'このPODの監督を支援するマネージャーを追加',
  noStakeholdersYet: 'まだステークホルダーがいません',
  settings: '設定',
  deletePod: 'PODを削除',
  addPodManager: 'PODマネージャーを追加',
  selectManagerToInvite: 'このPODに招待するマネージャーを選択:',
  noManagersAvailableToInvite: '招待できるマネージャーがいません。',
  selectAManager: 'マネージャーを選択',
  selectedManager: '選択されたマネージャー',
  inviteManager: 'マネージャーを招待',
  noTeamMembersYet: 'まだチームメンバーがいません',
  startByInvitingMembers: 'PODにメンバーを招待することから始める',
  inviteTeamMembers: 'チームメンバーを招待',
  existingMembers: '既存メンバー',
  inviteByEmail: 'メールで招待',
  searchByNameOrSkills: '名前またはスキルで検索...',
  optionalSelectUserToNotify: 'オプション：Slack経由で通知するユーザーを選択',
  pleaseSelectPodToEnableFields: '他のフィールドを有効にするためにPODを選択してください',
  selectedCandidates: '選択された候補者',
  selectCandidatesToInvite: 'このPODに招待する候補者を選択',
  availableCandidates: '利用可能な候補者',
  inviteNewMembersByEmail: 'メールで新しいメンバーを招待',
  emailAddresses: 'メールアドレス',
  enterEmailAddresses: 'メールアドレスを入力（カンマ区切り）',
  hidePodTeamMembers: 'POD検索セクションでこのPODチームメンバーを非表示（現在表示中）',
  technicalDetails: '技術詳細',
  currentTeamSize: '現在のチームサイズ',
  communicationDetails: 'コミュニケーション詳細',
  podReview: 'PODレビュー',
  rating: '評価',
  writeReview: 'レビューを書く',
  shareYourExperience: 'このPODでの経験を共有...',
  submitReview: 'レビューを送信',
  viewPod: 'PODを表示',
  managePod: 'PODを管理',
  editPod: 'PODを編集',
  skillsAndExperience: 'スキルと経験',
  reviews: 'レビュー',
  documents: 'ドキュメント',
  otherInfo: 'その他の情報',
  noWorkExperienceDataAvailable: '職歴データが利用できません',
  selectART: 'ARTを選択',
  selectAnART: 'ARTを選択',
  jiraConfiguration: 'Jira設定',
  jiraProjectKey: 'Jiraプロジェクトキー',
  jiraURL: 'Jira URL',
  jiraAdminEmail: 'Jira管理者メール',
  jiraAdminAPIToken: 'Jira管理者APIトークン',
  jiraOpenStoryBugStatus: 'Jiraオープンストーリー/バグステータス',
  jiraClosedStoryBugStatus: 'Jiraクローズドストーリー/バグステータス',
  gitHubConfiguration: 'GitHub設定',
  gitHubUsername: 'GitHubユーザー名',
  gitHubAPIToken: 'GitHub APIトークン',
  gitHubRepositoryName: 'GitHubリポジトリ名',
  circleCIConfiguration: 'CircleCI設定',
  circleCIGitHubUsername: 'CircleCI GitHubユーザー名',
  circleCIGitHubRepository: 'CircleCI GitHubリポジトリ',
  circleCIAPIToken: 'CircleCI APIトークン',
  sonarQubeConfiguration: 'SonarQube設定',
  sonarQubeCloudURL: 'SonarQube Cloud URL',
  sonarQubeAPIToken: 'SonarQube APIトークン',
  awsConfiguration: 'AWS設定',
  awsAccessKeyID: 'AWSアクセスキーID',
  awsSecretAccessKey: 'AWSシークレットアクセスキー',
  awsRegion: 'AWSリージョン',
  bitBucketConfiguration: 'BitBucket設定',
  bitBucketUsername: 'BitBucketユーザー名',
  bitBucketAppPassword: 'BitBucketアプリパスワード',
  bitBucketWorkspace: 'BitBucketワークスペース',
  openAIConfiguration: 'OpenAI設定',
  openAIToken: 'OpenAIトークン',
  storyPointsCalculation: 'ストーリーポイント計算',
  uploadStoryPointsCalculationFile: 'ストーリーポイント計算ファイルをアップロード',
  currentFile: '現在のファイル',
  notifications: '通知',
  markAllAsRead: 'すべて既読にする',
  tryAgain: '再試行',
  noNotificationsToDisplay: '表示する通知はありません',
  viewAllNotifications: 'すべての通知を表示',
  enterMultipleEmailsSeparatedByCommas: 'カンマ区切りで複数のメールを入力',
  addEmailAddressesToInvite: '新しいメンバーを招待するためのメールアドレスを追加',
  emailInvitationGuidelines: 'メール招待ガイドライン',
  inviteesWillReceiveInstructions: '招待者はこのPODに参加するための指示を受け取ります',
  theyWillNeedToCreateAccount: 'まだアカウントを持っていない場合は、アカウントを作成する必要があります',
  noCandidatesAvailable: '利用可能な候補者がいません',
  sendEmailInvites: 'メール招待を送信',

  processingDataAndGeneratingInsights: 'データを処理して洞察を生成中',
  retroHistory: 'レトロ履歴',
  filterByMember: 'メンバーでフィルター',
  podProductivity: 'POD生産性',
  totalTasks: '総タスク数',
  completed: '完了',
  clearFilters: 'フィルターをクリア',
  totalActivities: '総アクティビティ数',
  pendingApproval: '承認待ち',
  sortBy: '並べ替え',
  editSolution: 'ソリューションを編集',
  cannotDeleteAssociatedWithARTs: '削除できません - ARTと関連付けられています',
  editART: 'ARTを編集',
  createdDate: '作成日',
  podDetails: 'POD詳細',
  currentARTProject: '現在のART/プロジェクト',
  artProject: 'ART/プロジェクト',
  selectAvailability: '可用性を選択',
  selectSkill: 'スキルを選択',
  selectTimezone: 'タイムゾーンを選択',
  selectLocation: '場所を選択',
  selectBudget: '予算を選択',
  podMember: 'PODメンバー',
  addToPod: 'PODに追加',
  talentDetails: 'タレント詳細',
  reviewsFeedback: 'レビューとフィードバック',
  noEducationDataAvailable: '教育データが利用できません',
  noCertificationDataAvailable: '認定データが利用できません',
  clientReview: 'クライアントレビュー',
  noReviewsAvailableYet: 'まだレビューが利用できません',
  noClientReviews: 'このタレントはまだクライアントレビューを受けていません',
  resumeAvailable: '履歴書利用可能',
  viewDownloadResume: '候補者の履歴書を表示またはダウンロード',
  noResumeAvailable: '履歴書が利用できません',
  noResumeUploaded: 'このタレントは履歴書をアップロードしていません。',
  codingAssessment: 'コーディング評価',
  assessmentAvailable: '評価利用可能',
  viewAssessmentResults: '候補者のコーディング評価結果を表示',
  noAssessmentAvailable: '評価が利用できません',
  noAssessmentCompleted: 'このタレントはコーディング評価を完了していません。',
  partnerCompanyDetails: 'パートナー企業詳細',
  companyIntroductionVideo: '企業紹介ビデオ',
  videoNotSupported: 'あなたのブラウザはビデオタグをサポートしていません。',
  location: '場所',
  noPodsMatchingCriteria: 'あなたの基準に一致するPODが見つかりません',
  hirePod: 'PODを雇用',
  notificationHistory: '通知履歴',
  filter: 'フィルター',
  allNotifications: 'すべての通知',
  markSelected: '選択したものをマーク',
  unread: '未読',
  noNotificationsFound: '通知が見つかりません',
  searchNotifications: '通知を検索...',
  subscriptionManagement: 'サブスクリプション管理',
  choosePlanPrompt: 'あなたのニーズに最も適したプランを選択し、成長に合わせてスケールしてください',
  cancelSubscription: 'サブスクリプションをキャンセル',
  choosePlan: 'プランを選択',
  noPlansAvailable: '利用可能なプランがありません',
  noPlansHelpText: '後でもう一度確認するか、サポートにお問い合わせください。',
  currentPlanDetails: '現在のプラン詳細',
  renewalDate: '更新日',
  subscriptionId: 'サブスクリプションID',
  paymentMethod: '支払い方法',
  cardHolder: 'カード所有者',
  expires: '有効期限',
  brand: 'ブランド',
  billingHistory: '請求履歴',
  noInvoiceHistory: '請求書履歴はありません',
  needHelp: 'ヘルプが必要ですか？',
  supportText: 'サブスクリプションプランについてご質問がある場合やサポートが必要な場合は、サポートチームがお手伝いします。',
  contactSupport: 'サポートに連絡',
  completeSubscription: 'サブスクリプションを完了',
  planDetails: 'プラン詳細',
  planName: 'プラン名',
  basePrice: '基本価格',
  numberOfUsers: 'ユーザー数',
  billingCycle: '請求サイクル',
  orderSummary: '注文概要',
  annualDiscount: '年間割引',
  billingPeriod: '請求期間',
  tax: '税金',
  totalWithTax: '税込み合計',
  annually: '年間',
  continue: '続行',
  subscriptionSuccessful: 'サブスクリプション成功！',
  thankYouSubscribing: 'ご購読いただきありがとうございます',
  subscriptionActivated: 'サブスクリプションが正常にアクティベートされました。',
  goToDashboard: 'ダッシュボードへ',
  addPaymentMethod: '支払い方法を追加',
  cardNumber: 'カード番号',
  cardholderName: 'カード所有者名',
  expiryMonth: '有効期限月',
  expiryYear: '有効期限年',
  postalCode: '郵便番号',
  addCard: 'カードを追加',
  paymentChoice: '既存のカードを使用するか新しいカードを追加',
  existingCardText: '既にお持ちのカードがあります。末尾番号',
  useExistingCardPrompt: 'このサブスクリプションに使用しますか？',
  useExistingCard: '既存のカードを使用',
  addNewCard: '新しいカードを追加',
  processing: '処理中...',
  subscriptionSuccessDetails: '成功しました！',
  accessAllFeatures: 'サブスクリプションプランに含まれるすべての機能にアクセスできるようになりました。',
  editCardDetails: 'カード詳細を編集',
  managerInvite: 'マネージャー招待',
  talentInvite: 'タレント招待',
  invitePodManagers: 'ポッドマネージャーを招待するためのメールアドレスを入力',
  enterEmail: 'メールアドレスを入力',
  invite: '招待',
  yourInvoices: 'あなたの請求書',
  getCountIsseswithNoCritria: '受入基準のない課題の数を取得',
  noInvoices: '請求書がありません。',
  amountDue: '支払い予定額',
  amountPaid: '支払い済み額',
  noActiveSubscription: 'アクティブなサブスクリプションプランがありません。サブスクリプションを追加するには「購読」リンクをクリックしてください。',
 noActiveSubscriptionStart: 'アクティブなサブスクリプションプランがありません。',
  subscribe: '購読',
  noActiveSubscriptionEnd: 'リンクをクリックしてサブスクリプションを追加してください。'};

export default messagesJa;